// App.jsx
import React, { useState, useEffect } from 'react';
import AuthForm from './components/ui/AuthForm';
import LyraPromptOptimizer from './components/LyraPromptOptimizer';

export default function App() {
  const [authenticated, setAuthenticated] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('lyraToken');
    if (token) setAuthenticated(true);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('lyraToken');
    setAuthenticated(false);
  };

  return (
    <div className="min-h-screen bg-gray-100 p-4">
      {authenticated ? (
        <>
          <div className="flex justify-end mb-4">
            <button
              onClick={handleLogout}
              className="text-sm bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600"
            >
              Logout
            </button>
          </div>
          <LyraPromptOptimizer />
        </>
      ) : (
        <AuthForm onAuthSuccess={() => setAuthenticated(true)} />
      )}
    </div>
  );
}
